module.exports = __webpack_public_path__ + "img/w3_circle_add_black.3dfaf6b4.png";